import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M14.375 10V8.333a4.375 4.375 0 0 0-8.75 0V10l-1.667 3.542h12.084L14.375 10ZM7.5 13.958s0 2.084 2.5 2.084 2.5-2.084 2.5-2.084" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);